import type { Dispatch, SetStateAction } from 'react';
import { functionalUpdate, type OnChangeFn } from '@tanstack/react-table';

const toPlainObject = <S>(value: S): S =>
  typeof value === 'object' && value !== null && Object.getPrototypeOf(value) === null ? { ...value } : value;

/**
 * Adapts a React state setter into a TanStack `on*Change` handler that stores v9's null-prototype
 * state maps as plain objects, so `_isEmpty` and `Object.prototype` methods keep working on them.
 */
export const plainStateSetter =
  <S>(setState: Dispatch<SetStateAction<S>>): OnChangeFn<S> =>
  (updater) =>
    setState((old) => toPlainObject(functionalUpdate(updater, old)));
